import React from 'react';
import { useSelector } from 'react-redux'

import Select from '@material-ui/core/Select';
import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';

export default function SelectLibrary(props) {

    const libraryState = useSelector(state => state.library)
    const librariesFetched = !!libraryState.list.length

    return (
        <Select
            className={props.className}
            value={props.value || 0}
            onChange={props.onChange}
            disabled={!librariesFetched}
        >
            <MenuItem value={0}>
                <Grid item container justify="space-between">
                    <em>Todas as bibliotecas </em>
                </Grid>
            </MenuItem>
            {librariesFetched && libraryState.list.map((library, index) => (
                <MenuItem key={index} value={library['id-biblioteca']}>
                    <Typography variant="subheading" noWrap>
                        {`${library.sigla} - ${library.descricao}`}
                    </Typography>
                </MenuItem>
            ))}
        </Select>
    );
}